import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "pull-right" }
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = {
  class: "dropdown-menu",
  style: {"height":"50vh","min-width":"300px","min-height":"300px","overflow-y":"auto"}
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "modal-footer" }
const _hoisted_29 = {
  type: "submit",
  form: "notification-editor-form",
  class: "btn btn-primary"
}

import { computed, toRef } from 'vue'
    import { EditorState } from '@common/Common'

    import type { NotificationEditorViewModel } from '@Alternatives/Notifications/Components/NotificationEditor'
    import { CreateNotificationEventPayload, UpdateNotificationEventPayload } from '@Alternatives/Notifications/Components/NotificationEditor'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationEditor',
  props: {
    viewModel: {}
  },
  emits: ["create-notification", "update-notification"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const modalTitle = computed(() =>
        vm.value.state === EditorState.Creator
            ? 'Create notification'
            : 'Edit notification'
    )

    const confirmButtonLabel = computed(() =>
        vm.value.state === EditorState.Creator
            ? 'Create'
            : 'Update'
    )

    const statuses = computed(() => vm.value.statuses)
    const attributes = computed(() => vm.value.attributes)
    const emailSnippets = computed(() => vm.value.emailSnippets)
    const error = computed(() => vm.value.error)

    // ---------------- writable computed (VM fields) ----------------

    const enabled = computed({
        get: () => vm.value.enabled,
        set: v => { vm.value.enabled = v }
    })

    const name = computed({
        get: () => vm.value.name,
        set: v => { vm.value.name = v }
    })

    const description = computed({
        get: () => vm.value.description,
        set: v => { vm.value.description = v }
    })

    const statusId = computed({
        get: () => vm.value.statusId,
        set: v => { vm.value.statusId = v }
    })

    const prevStatusId = computed({
        get: () => vm.value.prevStatusId,
        set: v => { vm.value.prevStatusId = v }
    })

    const emailSubject = computed({
        get: () => vm.value.emailSubject,
        set: v => { vm.value.emailSubject = v }
    })

    const emailReplyToEmail = computed({
        get: () => vm.value.emailReplyToEmail,
        set: v => { vm.value.emailReplyToEmail = v }
    })

    const emailRecipientAttributeId = computed({
        get: () => vm.value.emailRecipientAttributeId,
        set: v => { vm.value.emailRecipientAttributeId = v }
    })

    const emailAdHocRecipients = computed({
        get: () => vm.value.emailAdHocRecipients,
        set: v => { vm.value.emailAdHocRecipients = v }
    })

    const emailMessage = computed({
        get: () => vm.value.emailMessage,
        set: v => { vm.value.emailMessage = v }
    })

    // ---------------- methods ----------------

    function insertEmailSnippet(content: string)
    {
        emailMessage.value = (emailMessage.value ?? '') + content
    }

    function onFormSubmit()
    {
        vm.value.clearValidationErrors()

        if (vm.value.state === EditorState.Creator)
        {
            emit(
                'create-notification',
                new CreateNotificationEventPayload(
                    name.value,
                    description.value,
                    enabled.value,
                    statusId.value,
                    prevStatusId.value,
                    emailSubject.value,
                    emailMessage.value,
                    emailRecipientAttributeId.value,
                    emailAdHocRecipients.value,
                    emailReplyToEmail.value
                )
            )
        }
        else
        {
            emit(
                'update-notification',
                new UpdateNotificationEventPayload(
                    vm.value.id,
                    name.value,
                    description.value,
                    enabled.value,
                    statusId.value,
                    prevStatusId.value,
                    emailSubject.value,
                    emailMessage.value,
                    emailRecipientAttributeId.value,
                    emailAdHocRecipients.value,
                    emailReplyToEmail.value
                )
            )
        }
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(modalTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (error.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("strong", null, _toDisplayString(error.value.ErrorCode.substring(0, error.value.ErrorCode.indexOf("."))) + ".", 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString(error.value.Error), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("form", {
                  id: "notification-editor-form",
                  onSubmit: _withModifiers(onFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((enabled).value = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, enabled.value]
                          ]),
                          _cache[10] || (_cache[10] = _createTextVNode(" Active ", -1 /* CACHED */))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", null, "Name (2 - 100 characters):", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
                          required: "",
                          minlength: "2",
                          maxlength: "100"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            name.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", null, "Description (optional):", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          rows: "6",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            description.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[13] || (_cache[13] = _createElementVNode("label", null, "Send when status is changed to:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((statusId).value = $event)),
                          class: "form-control"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statuses.value, (s) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: s.Id
                            }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_15))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, statusId.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Send when previous status was:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((prevStatusId).value = $event)),
                          class: "form-control"
                        }, [
                          _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "Any", -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statuses.value, (s) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: s.Id
                            }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_17))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, prevStatusId.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", null, "Email subject:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((emailSubject).value = $event)),
                          required: "",
                          minlength: "2",
                          maxlength: "500"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            emailSubject.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", null, "Reply to email:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((emailReplyToEmail).value = $event)),
                          required: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            emailReplyToEmail.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", null, "Recipients:", -1 /* CACHED */)),
                        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _cache[21] || (_cache[21] = _createElementVNode("small", { class: "text-muted" }, "Email recipients could be provided in two ways: from attribute and/or list of ad hoc emails separated by comma.", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((emailRecipientAttributeId).value = $event)),
                          class: "form-control"
                        }, [
                          _cache[18] || (_cache[18] = _createElementVNode("option", { value: null }, "Select attribute...", -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attr) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: attr.Id
                            }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_22))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, emailRecipientAttributeId.value]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "Add hoc emails separated by comma",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((emailAdHocRecipients).value = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            emailAdHocRecipients.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", null, "Message:", -1 /* CACHED */)),
                        _cache[24] || (_cache[24] = _createElementVNode("small", { class: "text-muted" }, "Message that will be send to the recipients.", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _cache[22] || (_cache[22] = _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                              "data-toggle": "dropdown"
                            }, "Insert", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emailSnippets.value, (es) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (insertEmailSnippet(es.Content))
                                }, _toDisplayString(es.Title), 9 /* TEXT, PROPS */, _hoisted_27))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ])
                          ])
                        ]),
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          rows: "6",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((emailMessage).value = $event)),
                          required: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            emailMessage.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", _hoisted_29, _toDisplayString(confirmButtonLabel.value), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})